/**
 * Phase 1 fixtures for one-state State Portal.
 * Shapes follow CONNECTIONS.json.
 * Each SOURCE_STATE gets its own resources doc id — never reuse another state's.
 */

import sourceStates from '@/components/state-portal-one-state/SOURCE_STATES.json'

const DEFAULT_SPORTS = [
  'Baseball', 'Basketball', 'Football', 'Softball', 'Track', 'Wrestling',
]

function normalizeState(sourceState) {
  return String(sourceState || '').trim().toUpperCase()
}

function stateName(code) {
  return sourceStates.states?.[code] || code
}

function associationOrg(code) {
  return {
    companyID: `${code.toLowerCase()}-org-state-association`,
    linkedNfhsCompanyID: `${code.toLowerCase()}-nfhs-state-association`,
    name: `${stateName(code)} State Association`,
    state: code,
    hasStatePortalAccessForInstructors: true,
    isActive: true,
  }
}

export function getFixtureSelectorOrganizations(states = []) {
  const codes = (Array.isArray(states) && states.length)
    ? states.map(normalizeState).filter(Boolean)
    : Object.keys(sourceStates.states || {})
  return codes.map(associationOrg)
}

export function getFixtureOrganizations(sourceState) {
  const code = normalizeState(sourceState)
  return {
    statePortalOrganizations: [associationOrg(code)],
    statePortalResources: null,
  }
}

export function getFixtureUsers() {
  return {
    statePortalUsers: [],
    totalCount: 0,
    page: 1,
    per_page: 25,
  }
}

export function getFixtureLearners() {
  return {
    learners: [],
    totalCount: 0,
    page: 1,
    per_page: 25,
  }
}

export function getFixtureResourcesDoc(sourceState) {
  const code = normalizeState(sourceState)
  return {
    id: `${code.toLowerCase()}-state-portal-resources`,
    state: code,
    isStatePartner: true,
    connectedSports: DEFAULT_SPORTS,
    New_Field_Requests: {
      connectedSports: DEFAULT_SPORTS,
      sportConnections: [],
      userRequirements: [],
    },
  }
}

export function getFixtureSports(sourceState) {
  const code = normalizeState(sourceState)
  return {
    state: code,
    availableSports: DEFAULT_SPORTS,
    connectedSports: DEFAULT_SPORTS,
  }
}

export function getFixtureRewards(sourceState) {
  return {
    state: normalizeState(sourceState),
    rewards: [],
    season: '',
  }
}

export function getFixtureReportSeries(sourceState) {
  return {
    state: normalizeState(sourceState),
    series: [],
  }
}
